<template>
  <div color="#fff">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="600"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="mr-3" dark v-bind="attrs" v-on="on">
          <span v-if="quantityCart >= 1">
            <v-badge
              value="15"
              color="primary"
              inline
              left
              :content="quantityCart"
            >
              <v-icon color="primary" size="30">mdi-cart</v-icon>
            </v-badge>
          </span>

          <span v-if="quantityCart < 1">
           
              <v-icon color="primary" size="30">mdi-cart</v-icon>
            </v-badge>
          </span>
        </v-btn>
      </template>

      <v-card>
        <v-card class="fill-height pa-4">
          <v-container>
            <template
              v-if="
                this.$store.getters.getCurrentCredentials.shoppingCartUser
                  .length === 0
              "
            >
              <v-col class="text-center">
                <p class="display-1 ml-3">Carrito vacío</p>
              </v-col>
            </template>

            <template v-else>
              <p class="display-1 ml-3">Carrito</p>
              <v-divider class="my-4" />
              <v-list three-line>
                <v-list-item
                  v-for="(item, index) in this.$store.getters
                    .getCurrentCredentials.shoppingCartUser"
                  :class="{ 'gray-rounded': index % 2 === 0 }"
                  :key="item.product_id"
                >
                  <v-img :src="item.img" max-width="50px" class="mr-5"></v-img>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >${{ numberWithCommas(item.price) }} x
                      {{ item.quantity }}
                    </v-list-item-subtitle>
                  

                    <v-list-item-subtitle
                      >Total: ${{
                        numberWithCommas(item.price * item.quantity)
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon
                        size="30"
                        color="red lighten-2"
                        @click="deleteItem(item)"
                        >mdi-trash-can
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider class="my-4" />
            

              <v-row no-gutters justify="end" class="mr-2 mt-7">
                <span class="headline mr-7">Total </span>
                <span class="headline">${{ getTotalPrice }}</span>
              </v-row>

            <!--   <v-row no-gutters justify="end" class="mr-2 mt-0">
                <span class="headline mr-7">    <v-switch
                    v-model="model"
                    hide-details
                    inset
                    :label="`Calcular envio: ${switchText.toString()}`"
                    >
                     </v-switch> </span>
             
              </v-row> -->
              <v-row no-gutters justify="end" class="mr-2 mt-2">

                <v-alert v-if="model"
    variant="tonal"
  >Starken cobro a destino costo estimado: $ {{ this.dataEnvio.tarifa }}</v-alert>
            
              </v-row>
             
              <v-row justify="end" class="mt-7">
                <v-btn large text class="red--text mr-4" @click="cleanCart()">
                  <v-icon left>mdi-trash-can</v-icon>
                  VACIAR CARRITO
                </v-btn>
                <v-btn
                
                  dark
                  large
                  color="gradient-45deg-purple-deep-orange"
                  @click="buyCart()"
                  :loading="buttonLoadingLogin"
                >
                  <v-icon left>mdi-cart</v-icon>
                  Realizar Pedido
                </v-btn>
              </v-row>
            </template>
          </v-container>
        </v-card>
      </v-card>
    </v-menu>

    <confirm ref="confirm"></confirm>
    <Alert ref="Alert"></Alert>
  </div>
</template>
<script>
import confirm from "@/components/Reusable/Confirm.vue";
import Alert from "@/components/Reusable/Alert.vue";

export default {
  name: "MainViewComponent",
  components: {
    confirm,
    Alert,
  },
  data: () => ({
    buttonLoadingLogin:false,
    listCategory: [],
    model: false,
    switchText:"NO",
    dataEnvio:0
  }),
  created() {},
  watch: {
    model(value) {
      if (value === false) {
       this.switchText="NO";
      }else{

     
        this.switchText="SI";

        this.$axios
        .post("https://apiprod.starkenpro.cl/quote/caja-tarifa",{
                                                                  "entrega": "DOMICILIO",
                                                                  "tipoServicio": "NORMAL",
                                                                  "codigoAgenciaDestino": 1345,
                                                                  "codigoAgenciaOrigen": 1197,
                                                                  "rutCliente": "",
                                                                  "codigoTipoPago": 1,
                                                                  "codigoCiudadOrigen": 1,
                                                                  "codigoCiudadDestino": 19,
                                                                  "rutDestinatario": "",
                                                                  "encargos": [
                                                                    {
                                                                      "tipoEncargo": "29",
                                                                      "alto": "10",
                                                                      "ancho": "7",
                                                                      "largo": "6",
                                                                      "kilos": "5"
                                                                    }
                                                                  ]
                                                                })
        .then((res) => {
      
          this.dataEnvio = res.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
        
      }
    },
  },
  computed: {
    quantityCart() {
      return this.$store.getters.getCurrentCredentials.shoppingCartUser.length;
    },
    getTotalPrice() {
      if (!this.$store.getters.getCurrentCredentials.shoppingCartUser)
        this.$store.getters.getCurrentCredentials.shoppingCartUser = [];
      let totalPrice = 0;
      if (
        this.$store.getters.getCurrentCredentials.shoppingCartUser.length !== 0
      ) {
        this.$store.getters.getCurrentCredentials.shoppingCartUser.forEach(
          (el) => (totalPrice += el.quantity * el.price)
        );
      }
      this.total = totalPrice;
      return this.numberWithCommas(totalPrice);
    },
    getId() {
      return this.$store.getters.getCurrentCredentials.id;
    },
  },
  methods: {
    buyCart(){

      this.buttonLoadingLogin =true;

      const formData = {
        user_id:this.getId,
        products: this.$store.getters.getCurrentCredentials.shoppingCartUser,
        price:  this.getTotalPrice.replace(/,/g,''),
        quantity: this.quantityCart,
   
      };

      this.$axios
          .post("/api/createOrden", formData)
          .then((response) => {
            this.$toast.success("Orden Creada", "");
            this.cleanCart();
            this.buttonLoadingLogin =false;
         /*    this.isLoading = false;
            this.show = false;
            this.$emit("updateProducts");
            this.formObj.id = ""; */
          })
          .catch((error) => {
            this.buttonLoadingLogin =false;
            this.$swal.fire("Error al crear orden", error, "error");
         
          });

  


    },
    deleteItem(item) {
      this.$store
        .dispatch("deleteShoppingCart", item)
        .then((response) => {
          this.$store.commit("showSnackbar", {
            text: "Producto eliminado con éxito",
            color: "success",
          });
        })
        .catch((error) => {
          this.$refs.Alert.open("Error", "Problemas al realizar la operación", {
            color: "red",
          });
        });
    },
    cleanCart() {
      this.$store
        .dispatch("clearCart", "")
        .then((response) => {
         /*  this.$store.commit("showSnackbar", {
            text: "El carrito esta vacio",
            color: "success",
          }); */
        })
        .catch((error) => {
          this.$refs.Alert.open("Error", "Problemas al realizar la operación", {
            color: "red",
          });
        });
    },
    numberWithCommas(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {},
};
</script>
